import React from "react";
import s from "./ReportPreview.module.scss";

// A4 dimensions (assuming 96 DPI)
export const A4_WIDTH_PX = 840; // 210mm
export const A4_HEIGHT_PX = 1200; // 297mm

interface IProps extends React.PropsWithChildren<any> {
  scale: number;
  isLandscape?: boolean;
}

export const ReportPreview = ({ children, scale, isLandscape }: IProps) => {
  return (
    <div className={s.previewContainer}>
      <div className={s.scrollContainer}>
        <div
          className={s.scaleContainer}
          style={{
            transform: `scale(${scale})`,
            width: isLandscape ? A4_HEIGHT_PX : A4_WIDTH_PX,
            minWidth: isLandscape ? A4_HEIGHT_PX : A4_WIDTH_PX,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
